/**
 * OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateCrossOrbitalSLDocScreen
 */

import { useOrbDocTutorialsIntermediateCrossOrbitalSLDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalSLDocScreenLogic';
import type { OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateCrossOrbitalSLDocView as OrbDocTutorialsIntermediateCrossOrbitalSLDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateCrossOrbitalSLDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalSLDocBodyView';
import { OrbDocTutorialsIntermediateCrossOrbitalSLDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalSLDocFooterView';
import { OrbDocTutorialsIntermediateCrossOrbitalSLDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateCrossOrbitalSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateCrossOrbitalSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateCrossOrbitalSL" trait="OrbDocTutorialsIntermediateCrossOrbitalSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateCrossOrbitalSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateCrossOrbitalSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView;
